'use client';

import { useEffect } from 'react';
import { pageTrackingObjectUpdate } from 'helpers/tagular';

export const useCohesionConfig = (pageType: string) => {
  useEffect(() => {
    pageTrackingObjectUpdate(pageType, true);
  }, [pageType]);
};
